<contact-banner></contact-banner>
<div id="conatct-us" class="ez-section-card">
    <div class="ez-technology-platform-section">
        <div class="technologies-section">
            <div class="technologies-section-bg">
                <contact-list></contact-list>
            </div>
        </div>
    </div>
</div>